import BaseModel from "../base/baseModel";

export default class ProdutoDcbModel extends BaseModel {
    id?: number = null;
    franquiaId?: number = null;
    descricao: string = null;
    codigo: string = null;
    cas: string = null;
}